import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getConsumerDetail, getVitalsReference } from "../lib/api";
import { useEffect } from "react";
import { cn } from "../shared/utils";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { useStore } from "../store";
import { useQuery } from "@tanstack/react-query";

const ECGView = () => {
  let navigate = useNavigate();
  const ecgSession = useStore((state) => state.selectedEcg);
  const [ecgData, setEcgData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [heartRate, setHeartRate] = useState();
  const containerRef = useRef(null);
  const [rangeWidth, setRangeWidth] = useState(0);
  const [startWidth, setStartWidth] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const { data, isLoading: vitalLoading } = useQuery({
    queryKey: ["vitalRef"],
    queryFn: () => getVitalsReference(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const vitalInfos = data?.data?.result || [];
  const hrReference = vitalInfos?.find((e) => e.name == "hr");
  useEffect(() => {
    const calculateWidths = () => {
      if (containerRef.current) {
        const divWidth = containerRef.current.clientWidth;
        const normalRangeWidth = divWidth * 0.6;
        const normalStart =
          hrReference?.normal_range?.lower_limit -
          hrReference?.allowed_range?.lower_limit;
        const normalEnd =
          hrReference?.allowed_range?.upper_limit -
          hrReference?.normal_range?.upper_limit;

        setContainerWidth(divWidth);
        if (normalStart == 0) {
          setStartWidth(0);
        } else if (normalEnd == 0) {
          setStartWidth(divWidth - normalRangeWidth);
        } else {
          setStartWidth(
            (normalStart / (normalEnd + normalStart)) * normalRangeWidth
          );
        }
        setRangeWidth(normalRangeWidth);
      }
    };

    calculateWidths();
    setHeartRate(
      parseInt(ecgData?.inference?.extras?.heart_rate.match(/\d+/)[0])
    );
    window.addEventListener("resize", calculateWidths);

    return () => {
      window.removeEventListener("resize", calculateWidths);
    };
  }, [ecgData,hrReference]);
  const getCurrentPos = (value) => {
    if (value < hrReference?.allowed_range?.lower_limit) {
      return {
        left: 0,
        color: "#B33A3A",
      };
    } else if (value > hrReference?.allowed_range?.upper_limit) {
      return {
        left: containerWidth,
        color: "#B33A3A",
      };
    }

    let left = 0;
    let color = "#B33A3A";

    if (
      value >= hrReference?.normal_range?.lower_limit &&
      value <= hrReference?.normal_range?.upper_limit
    ) {
      const posUnit =
        rangeWidth /
        (hrReference?.normal_range?.upper_limit -
          hrReference?.normal_range?.lower_limit);
      left =
        startWidth + (value - hrReference?.normal_range?.lower_limit) * posUnit;
      color = "#4BB543";
    } else if (value < hrReference?.normal_range?.lower_limit) {
      const posUnit =
        startWidth /
        (hrReference?.normal_range?.lower_limit -
          hrReference?.allowed_range?.lower_limit);
      left = (value - hrReference?.allowed_range?.lower_limit) * posUnit;
    } else if (value > hrReference?.normal_range?.upper_limit) {
      const posUnit =
        startWidth /
        (hrReference?.allowed_range?.upper_limit -
          hrReference?.normal_range?.upper_limit);
      left =
        startWidth +
        rangeWidth +
        (value - hrReference?.normal_range?.upper_limit) * posUnit;
    }

    return { left, color };
  };
  const getNormalPos = () => {
    return {
      width: rangeWidth,
      left: startWidth,
    };
  };
  const getEcgInfo = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }
      // const ecgSession = sessionStorage.getItem("currentEcg")
      //   ? JSON.parse(sessionStorage.getItem("currentEcg"))
      //   : null;
      if (ecgSession) {
        setEcgData(ecgSession);
        setLoading(false);
        return;
      }
      setLoading(true);
      const res = await getConsumerDetail(patientId);
      const result = res?.data?.result?.ecg;
      const ecgDetails = result?.[result?.length - 1];
      if (result?.[result?.length - 1])
        sessionStorage.setItem("currentEcg", JSON.stringify(ecgDetails));
      setEcgData(ecgDetails);
      setLoading(false);
      // console.log(ecgDetails, "ecg");
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEcgInfo();
  }, []);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const goToViewDoc = (doc) => {
    console.log(doc)
    // sessionStorage.setItem('currentEcg',JSON.stringify(item))
    navigate(`/documentView/${doc.id}`);
  };
  return (
    <div className="bg-gray-50 min-sh-screen">
      <div className="flex justify-between text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 ">
        <div>
          <Link className="flex" onClick={handleGoBack}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
            <div className="pl-2 flex-1 mt-0.5">
              <h4 className="font-semibold text-sm">ECG Measurement</h4>
            </div>
          </Link>
        </div>
        {ecgData?.file_type?.toLowerCase() == "pdf" && ecgData?.filepath && (
          <div className="absolute top-4 right-2">
            <button
              className={cn(
                "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
                "h-9 px-4 py-2"
              )}
              onClick={() => goToViewDoc(ecgData)}
            >
              View ECG
            </button>
            {/* <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
              <DialogTrigger
                asChild
              >

                <button
                  className={cn(
                    "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                    "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
                    "h-9 px-4 py-2"
                  )}
                  
                >
                  View Ecg
                </button>

              </DialogTrigger>
              <DialogContent className="sm:max-w-[80%] max-w-[90%]">
                <DialogHeader>
                  <DialogTitle>Your Ecg</DialogTitle>
                  <iframe
                    src={ecgData.filepath}
                    width="100%"
                    height="400px"
                    title="ecg"
                  ></iframe>
                </DialogHeader>
              </DialogContent>
            </Dialog> */}
          </div>
        )}
      </div>
      <div className=" flex-1 overflow-scroll hideScroll  text-gray-500flex flex-col pt-16 p-4">
        <div className="flex flex-col h-[calc(100vh-120px)]">
          {isLoading && (
            <>
              <div className="animate-pulse h-full flex flex-col  w-full  items-center  bg-gradient-to-r from-white to-zinc-100  ">
                <div className="w-full h-2/5 bg-slate-200 mb-4"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-full  bg-slate-200 h-5 my-1"></div>
                <div className="w-[260px]  bg-slate-200 h-9 rounded-2xl mt-5"></div>
              </div>
            </>
          )}
          {!isLoading && (
            <>
              <div className="bg-blue-200">
                <div className="flex w-full justify-center my-2">
                  <div
                    className={` ${
                      ecgData?.inference?.alert ? "bg-red-100" : "text-white "
                    } flex flex-col gap-2 justify-center items-center mb-4 w-36 h-36 rounded-full border-8 border-white bg-primary`}
                  >
                    <div className="flex items-end text-center font-bold text-4xl  leading-[1]">
                      {" "}
                      {ecgData?.inference?.extras?.heart_rate?.split(" ")[0]}
                      <span className=" text-center font-semibold text-sm lowercase  flex  items-end">
                        {ecgData?.inference?.extras?.heart_rate?.split(" ")[1]}
                      </span>
                    </div>
                    <div className=" flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="red"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-7 h-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                        />
                      </svg>
                      {ecgData?.inference?.alert ? (
                        <p className="text-xs font-semibold text-red-700 animate-pulse">
                          Critical
                        </p>
                      ) : (
                        <p className="text-xs font-semibold text-white">
                          Normal
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex  justify-center mb-4">
                  <img
                    src={`data:image/jpeg;base64,${ecgData?.inference?.image_stream}`}
                    className="object-contain h-2/5 w-4/5"
                    alt="ecg"
                  />
                </div>
              </div>
              <div className=" flex">
                <div
                  ref={containerRef}
                  className="relative w-full h-2 bg-[#B33A3A] rounded-xl my-8"
                >
                  <div
                    style={{
                      left: getCurrentPos(heartRate).left,
                      color: getCurrentPos(heartRate).color,
                    }}
                    className="absolute tooltip"
                  >
                    <div
                      style={{
                        backgroundColor: getCurrentPos(heartRate).color,
                      }}
                      className="absolute z-10 bottom-3 left-1/2 transform -translate-x-[50%]  text-white text-xs px-2 py-1 rounded whitespace-nowrap "
                    >
                      {ecgData?.inference?.extras?.heart_rate}
                    </div>
                  </div>
                  <span
                    style={getNormalPos()}
                    className="absolute h-2 bg-[#4BB543] z-10 rounded-xl"
                  >
                    <span className=" absolute left-0 -translate-x-1/2  mt-2">
                      {hrReference?.normal_range?.lower_limit}
                    </span>
                    <span className="absolute right-0 translate-x-1/2 mt-2">
                      {hrReference?.normal_range?.upper_limit}
                    </span>
                  </span>
                </div>
              </div>
              <div>
                <p className="text-base py-1">
                  Ecg duration : {ecgData?.inference?.extras?.duration}
                </p>
                {ecgData?.inference?.extras?.ecg_category && (
                  <p className="text-base py-1">
                    Ecg category : {ecgData?.inference?.extras?.ecg_category}
                  </p>
                )}
                <p className="text-base py-1">
                  Heart rate : {ecgData?.inference?.extras?.heart_rate || "-"}
                </p>
                <p className="text-base py-1">
                  Mains frequency :{" "}
                  {ecgData?.inference?.extras?.mains_frequency || "-"}
                </p>
                <p className="text-base py-1">
                  Scale mm/mV :{" "}
                  {ecgData?.inference?.extras?.scale_mm_per_mV || "-"}
                </p>
                <p className="text-base py-1">
                  Scale mm/s :{" "}
                  {ecgData?.inference?.extras?.scale_mm_per_s || "-"}
                </p>
              </div>
              <div
                className={`my-4 border ${
                  ecgData?.inference?.alert ? "bg-red-100" : "bg-blue-100"
                }  rounded-md w-full p-2 px-4`}
              >
                <div>
                  {ecgData?.inference?.comments && (
                    <p
                      className={`text-base font-semibold py-1 ${
                        ecgData?.inference?.alert
                          ? "text-red-700 "
                          : "text-blue-500"
                      } `}
                    >
                      Comment :{" "}
                      <span className="pl-2">
                        {" "}
                        {ecgData?.inference?.comments || "-"}
                      </span>
                    </p>
                  )}
                  {ecgData?.inference?.alert ? (
                    <p className="text-base font-semibold text-red-700 animate-pulse">
                      Your ECG has variation, Please consult a doctor from our
                      doctor list.
                    </p>
                  ) : (
                    <p className="text-base font-semibold text-blue-500">
                      Your ECG looks like normal, but you can still consult a
                      doctor if you want.
                    </p>
                  )}
                </div>
                <button
                  className={cn(
                    "inline-flex items-center justify-center whitespace-nowrap rounded-3xl text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50",
                    "bg-primary text-primary-foreground shadow hover:opacity-[.75]",
                    "h-9 px-4 py-2 w-full mt-2",
                    `${
                      ecgData?.inference?.alert ? "bg-red-700 " : "bg-blue-500"
                    } `
                  )}
                  onClick={() => navigate("/schedule")}
                >
                  Find Available Doctor
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ECGView;
